import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service.js';
import '../../pages/ProfitAndLossReport/ProfitAndLossReport.css';
import backIcon from '../../assests/images/left-arrow.png';
import { useBack } from "use-back";
import { useCallback } from 'react';
import EnumsService from '../../Services/enums.service.js';
import ReportsService from '../../Services/reports.service.js';
import { ToastContainer, toast } from "react-toastify";
import { Modal, Typography, colors, Dialog, DialogTitle, DialogContent, DialogActions, ListItem, TextField, Button } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { LineChart, XAxis, YAxis, LineSeries } from '@mui/x-charts';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Checkbox, FormGroup } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import TrialBalanceReportHtml from '../../Components/LedgerReport/TrialBalanceReportHtml/TrialBalanceReportHtml.js';
import AdvancedDropdown from '../../Components/AdvancedDropdown/AdvancedDropdown.js';
import PuffLoader from "react-spinners/PuffLoader";
import AddAccountCardModal from '../../Components/Widgets/AddAccountCardModal/AddAccountCardModal.jsx';
import debounce from 'lodash.debounce';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import { isEqual } from 'lodash';
import { store } from '../../store';
import './LedgerReport.css'
import { PermissionsContext } from '../../Contexts/Permissions.js';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, IconButton, Box
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp, Token } from '@mui/icons-material';

import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import dayjs, { Dayjs } from 'dayjs';
import FormControlLabel from '@mui/material/FormControlLabel';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import TrialBalanceTable from '../../Components/LedgerReport/SubComponent/TrialBalanceTable.jsx';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import DocumentService from '../../Services/documents.service.js';
import BalanceControlDialog from '../../Components/BankPages/SubComponents/BalanceControlDialog.js';
import PalcodePlacementCheckDialog from '../../Components/BankPages/SubComponents/PalcodePlacementCheckDialog.js';
import ProfitAndLossReportHtml from '../../Components/LedgerReport/ProfitAndLossReportHtml/ProfitAndLossReportHtml.js';
import { el, is } from 'date-fns/locale';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import ProfitAndLossHtmlPreview from '../../Components/Widgets/ProfitAndLossHtmlPreview/ProfitAndLossHtmlPreview.jsx';
import EditableProfitAndLossHtmlPreview from '../../Components/Widgets/EditableProfitAndLossHtmlPreview/EditableProfitAndLossHtmlPreview.jsx';
import {
    setPalCodesData,
    setPalDates,
    setBalanceControl,
    setPalcodePlacementViolations,
    setTrialBalanceData,
    setLoading,
    setEndDate,
    setStartDate,
    setStartYearDate,
    setEndYearDate,
    setLastFetchDates
} from '../../store/reducers/ledgerReportSlice.js';
import { setRange } from '../../store/reducers/reportPeriodSlice';
import '../Document/Document.scss';

const chartSetting = {
    yAxis: [
        {
            label: 'rainfall (mm)',
        },
    ],
    width: 500,
    height: 300,
    sx: {
        [`.${axisClasses.right} .${axisClasses.label}`]: {
            transform: 'translate(-20px, 0)',
        },
    },
};
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Helper function to adjust date to Israel time zone (UTC+2)
const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};

// Helper function to get the start of the year in Israel time
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

// Helper function to get the current month in Israel time
const getCurrentMonth = (date) => {
    const currentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the current month

    return adjustToIsraelTime(currentMonth);
};
const formatDate = (date) => {
    const d = new Date(date);
    const month = ('0' + (d.getMonth() + 1)).slice(-2); // Add leading zero if needed
    const year = d.getFullYear();
    return `${month}/${year}`;
};

const formatDateRangeFromString = (dateRangeString) => {
    const [startDateStr, endDateStr] = dateRangeString.split(' $ ');

    const formatSingleDate = (dateStr) => {
        const date = new Date(dateStr);
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensure month is in MM format
        const year = date.getFullYear();
        return `${month}/${year}`;
    };

    const startFormatted = formatSingleDate(startDateStr);
    const endFormatted = formatSingleDate(endDateStr);

    return `${startFormatted} - ${endFormatted}`;
};

/**
 * CustomYearDatePicker always emits Dec 31 23:59:59 UTC for a chosen year.
 * Yearly fetches must use full-year bounds (Jan 1 → Dec 31), otherwise switching
 * Monthly → Yearly can send startDate === endDate === Dec 31.
 *
 * Monthly pickers historically stored day=10 placeholders (e.g. 2025-01-10 → 2025-12-10).
 * Monthly fetches must use real month bounds (1st 00:00:00 → last day 23:59:59).
 */
const toUtcYearStart = (year) => new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0));
const toUtcYearEnd = (year) => new Date(Date.UTC(year, 11, 31, 23, 59, 59, 0));
const toUtcMonthStart = (year, monthIndex) => new Date(Date.UTC(year, monthIndex, 1, 0, 0, 0, 0));
const toUtcMonthEnd = (year, monthIndex) =>
    new Date(Date.UTC(year, monthIndex + 1, 0, 23, 59, 59, 0));

const getUtcFullYearSafe = (date, fallbackYear = new Date().getUTCFullYear()) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return fallbackYear;
    }
    return date.getUTCFullYear();
};

const getUtcMonthSafe = (date, fallbackMonth = 0) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return fallbackMonth;
    }
    return date.getUTCMonth();
};

const normalizeYearlyDateRange = (startYearDate, endYearDate) => {
    const startYear = getUtcFullYearSafe(startYearDate);
    const endYear = getUtcFullYearSafe(endYearDate, startYear);
    const from = Math.min(startYear, endYear);
    const to = Math.max(startYear, endYear);
    return {
        start: toUtcYearStart(from),
        end: toUtcYearEnd(to),
    };
};

const normalizeMonthlyDateRange = (startDate, endDate) => {
    const startYear = getUtcFullYearSafe(startDate);
    const endYear = getUtcFullYearSafe(endDate, startYear);
    const startMonth = getUtcMonthSafe(startDate, 0);
    const endMonth = getUtcMonthSafe(endDate, 11);

    let start = toUtcMonthStart(startYear, startMonth);
    let end = toUtcMonthEnd(endYear, endMonth);

    if (start.getTime() > end.getTime()) {
        start = toUtcMonthStart(endYear, endMonth);
        end = toUtcMonthEnd(startYear, startMonth);
    }

    return { start, end };
};

function LedgerReport() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const { userTypeContext, permissionsState } = useContext(PermissionsContext);
    // const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const location = useLocation();
    // const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [type, setType] = useState('');
    const [isProfitAndLoss, setIsProfitAndLoss] = useState(false);
    const { goBack } = useContext(NavHistoryContext);
    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);
    //   new MUI table imports
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    const [focused, setFocused] = useState(false);
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;// Flag to toggle between single date and range

    // Date basis for aggregation. true → bucket documents by their document date,
    // false → bucket by registration month. Default true (document date).
    const [filterByDocumentDate, setFilterByDocumentDate] = useState(() => {
        const stored = localStorage.getItem('ledgerReportFilterByDocumentDate');
        return stored === null ? false : stored === 'true';
    });
    /** Mirrors filterByDocumentDate so fetches triggered right after a toggle read the new value. */
    const filterByDocumentDateRef = useRef(filterByDocumentDate);
    filterByDocumentDateRef.current = filterByDocumentDate;


    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const handleSortChange = (key, type) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };

    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();

    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };
    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }

    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] =
        useState(false);
    // const [palCodesData, setPalCodesData] = useState([]);
    // const [balanceControl, setBalanceControl] = useState([]);
    // const [trialBalanceData, setTrialBalanceData] = useState(null);
    // const [palDates, setPalDates] = useState([]);

    const [openRows, setOpenRows] = useState({});
    const [openReportModal, setOpenReportModal] = useState(false);
    const [openProfitAndLossModal, setOpenProfitAndLossModal] = useState(false);
    const [openBalanceControlModal, setOpenBalanceControlModal] = useState(false);
    // null = closed, otherwise the check shown: 'PalcodePlacement' | 'MissingPalCode'
    const [palcodeCheckType, setPalcodeCheckType] = useState(null);
    const [showAccountCardsWithZeros, setShowAccountCardsWithZeros] = useState(true);
    const [openMatchingProfitAndLossModal, setOpenMatchingProfitAndLossModal] = useState(false);
    const [openEditableProfitAndLossModal, setOpenEditableProfitAndLossModal] = useState(false);
    const [editableProfitAndLossHtmlContent, setEditableProfitAndLossHtmlContent] = useState('');
    const [editableShowPercentageColumn, setEditableShowPercentageColumn] = useState(false);
    const [profitAndLossHtmlContent, setProfitAndLossHtmlContent] = useState('');
    const [profitAndLossYear, setProfitAndLossYear] = useState(null);
    const [profitAndLossTotalBalance, setProfitAndLossTotalBalance] = useState(0);
    // Foreign-currency selection for the trial-balance / P&L HTML reports.
    // null = shekel (default), 'MIXED' = all currencies together, number = a specific currency enum value.
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [availableCurrencies, setAvailableCurrencies] = useState([]);
    const [matchingShowCards, setMatchingShowCards] = useState(true);
    const [matchingShowPercentageColumn, setMatchingShowPercentageColumn] = useState(false);

    const [palCodesOptions, setPalCodesOptions] = useState([{ key: '', label: '', value: "" }]);

    // const [startDate, setStartDate] = useState(() => {
    //     const storedStartDateString = localStorage.getItem('StartDate');
    //     const startDate = storedStartDateString ? new Date(storedStartDateString) : getStartOfYear(new Date());
    //     return startDate;
    // });

    // const [endDate, setEndDate] = useState(() => {
    //     const storedEndDateString = localStorage.getItem('EndDate');
    //     const endDate = storedEndDateString ? new Date(storedEndDateString) : getCurrentMonth(new Date());
    //     return endDate;
    // });

    // const [startYearDate, setStartYearDate] = useState(() => {
    //     const storedStartYearDateString = localStorage.getItem('StartYearDate');
    //     const startDate = storedStartYearDateString ? new Date(storedStartYearDateString) : getStartOfYear(new Date());
    //     return new Date(Date.UTC(startDate.getFullYear(), 0, 1));
    // });

    // const [endYearDate, setEndYearDate] = useState(() => {
    //     const storedEndYearDateString = localStorage.getItem('EndYearDate');
    //     const endDate = storedEndYearDateString ? new Date(storedEndYearDateString) : getCurrentMonth(new Date());
    //     return new Date(Date.UTC(endDate.getFullYear(), 11, 31));
    // });

    // const [isMonthly, setIsMonthly] = useState(() => {
    //     return JSON.parse(localStorage.getItem('isMonthly_Ledger')) || true;
    // });
    const [isDataFetched, setIsDataFetched] = useState(false);

    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [palCode, setPalCode] = useState("");


    const dispatch = useDispatch();
    const {
        palCodesData,
        palDates,
        balanceControl,
        palcodePlacementViolations,
        trialBalanceData,
        loading,
        endDate,
        startDate,
        startYearDate,
        endYearDate,
        cache,
        lastFetchStartDate,
        lastFetchEndDate

    } = useSelector((state) => state.ledgerReportSlice);
    const {
        isMonthly,
    } = useSelector((state) => state.reportPeriodSlice);

    const getCacheKey = (startDate, endDate) =>
        `${startDate.toISOString()}_${endDate.toISOString()}`;

    const fetchEnums2 = async (user, token, client) => {
        await refreshData();
    }

    const fetchEnums = async (token, client) => {
        if (!client || !token) return;

        setLoading(true);
        try {
            // Parallel requests
            const [palCodesResponse, accountsResponse] = await Promise.all([
                EnumsService.GetPalCodesByAccountantId(client.accountantId, token),
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
            ]);

            // Process PalCodes
            if (palCodesResponse.ok) {
                const palCodes = await palCodesResponse.json();
                if (Array.isArray(palCodes) && palCodes.length > 0) {
                    // Sort PAL codes by their orderNumber (set from CSV line order)
                    const sortedPalCodes = [...palCodes].sort((a, b) => {
                        const orderA = a.orderNumber ?? 9999;
                        const orderB = b.orderNumber ?? 9999;
                        return orderA - orderB;
                    });
                    
                    const formatted = sortedPalCodes.map((p) => ({
                        key: p.palCodeId,
                        label: p.palCodeId,
                        value: p.palCodeId,
                    }));
                    setFormattedPalCodeOptions(formatted);
                    setPalCodesOptions([
                        { key: 'NonPalCode', value: t('NonPalCode'), label: t('NonPalCode') },
                        ...formatted,
                    ]);
                }
            }

            // Process Account Cards
            if (accountsResponse.ok) {
                const accounts = await accountsResponse.json();
                const mappedAccounts = accounts.map((a) => ({
                    label: a.name,
                    value: a.cardId,
                }));
                setAccountCardOptions(accounts); // full object
                // If needed: setAccountCardDropdownOptions(mappedAccounts);
            }
        } catch (error) {
            console.error(error);
            toast.error(t('fetchEnumsError'));
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = useCallback(
        (accountCard, palCode) => {
            const range = isMonthly
                ? normalizeMonthlyDateRange(startDate, endDate)
                : normalizeYearlyDateRange(startYearDate, endYearDate);

            navigate('/AccountCardDashboard', {
                state: {
                    client,
                    accountCardId: accountCard.cardId,
                    accountCardName: accountCard.name,
                    palCodeName: palCode.palCodeId,
                    startDate: range.start,
                    endDate: range.end,
                    isMonthly,
                    filterByDocumentDate,

                    /* 🔑 new keys ------------------------------------------------ */
                    isSortCodeReport: true,
                    breadcrumbs: ['Reports', 'LedgerReport'],
                    /* ----------------------------------------------------------- */
                },
            });
        },
        [navigate, client, startDate, endDate, startYearDate, endYearDate, isMonthly, filterByDocumentDate]
    );

    // const handleRangeChange = () => {
    //     setIsMonthly(prevIsMonthly => {
    //         const newIsMonthly = !prevIsMonthly;
    //         localStorage.setItem('isMonthly', JSON.stringify(newIsMonthly));
    //         return newIsMonthly;
    //     });
    // };



    const lastMonthly = useRef({ start: startDate, end: endDate });

    const handleRangeChange = (monthly) => {
        if (monthly === isMonthly) return;
        if (isMonthly) {
            lastMonthly.current = normalizeMonthlyDateRange(startDate, endDate);
        }
        if (!monthly) {
            // Monthly → Yearly: carry over years from the monthly range
            const { start, end } = normalizeYearlyDateRange(startDate, endDate);
            dispatch(setStartYearDate(start));
            dispatch(setEndYearDate(end));
        } else {
            // Yearly → Monthly: carry over years from the yearly pickers
            // (Jan of start year → Dec of end year), not the previous monthly session.
            const { start, end } = normalizeMonthlyDateRange(startYearDate, endYearDate);
            lastMonthly.current = { start, end };
            dispatch(setStartDate(start));
            dispatch(setEndDate(end));
        }
        dispatch(setRange({ isMonthly: monthly }));
        localStorage.setItem('isMonthly', JSON.stringify(monthly));
    };

    useEffect(() => {
        if (!isMonthly) return;
        // Keep monthly bounds aligned after toggle (already set in handleRangeChange).
        const restored = normalizeMonthlyDateRange(
            lastMonthly.current?.start || startDate,
            lastMonthly.current?.end || endDate
        );
        dispatch(setStartDate(restored.start));
        dispatch(setEndDate(restored.end));
        lastMonthly.current = restored;
    }, [isMonthly]);


    const handleStartDateChange = async (date) => {
        localStorage.setItem('StartDate', date);
        
        let startDateToSet;
        if (isMonthly) {
            startDateToSet = date;
            dispatch(setStartDate(date));
        } else {
            // CustomYearDatePicker returns Dec 31 — normalize start to Jan 1 of that year.
            startDateToSet = toUtcYearStart(getUtcFullYearSafe(date));
            dispatch(setStartYearDate(startDateToSet));
        }
        
        // Call fetch functions with current end date
        const currentEndDate = isMonthly
            ? endDate
            : normalizeYearlyDateRange(startDateToSet, endYearDate).end;
        fetchPalCodesData(startDateToSet, currentEndDate, processedFilesCheckbox);
        fetchBalanceControl(startDateToSet, currentEndDate, processedFilesCheckbox);
        await fetchTrialBalanceData(startDateToSet, currentEndDate, processedFilesCheckbox, true);
    };

    const handleEndDateChange = async (date) => {
        localStorage.setItem('EndDate', date);
        
        let endDateToSet;
        if (isMonthly) {
            endDateToSet = date;
            dispatch(setEndDate(date));
        } else {
            // CustomYearDatePicker returns Dec 31 — keep end-of-year explicitly.
            endDateToSet = toUtcYearEnd(getUtcFullYearSafe(date));
            dispatch(setEndYearDate(endDateToSet));
        }
        
        // Call fetch functions with current start date
        const currentStartDate = isMonthly
            ? startDate
            : normalizeYearlyDateRange(startYearDate, endDateToSet).start;
        fetchPalCodesData(currentStartDate, endDateToSet, processedFilesCheckbox);
        fetchBalanceControl(currentStartDate, endDateToSet, processedFilesCheckbox);
        await fetchTrialBalanceData(currentStartDate, endDateToSet, processedFilesCheckbox, true);
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        let endDateToSet;

        if (type === 'year') {
            updatedDate = toUtcMonthEnd(newDate.getFullYear(), getUtcMonthSafe(endDate, 11));
        } else if (type === 'month') {
            updatedDate = toUtcMonthEnd(getUtcFullYearSafe(endDate), newDate.getMonth());
        }

        if (isMonthly) {
            endDateToSet = updatedDate;
            dispatch(setEndDate(updatedDate));
        } else {
            endDateToSet = toUtcYearEnd(newDate.getFullYear());
            dispatch(setEndYearDate(endDateToSet));
        }

        const activeStart = isMonthly
            ? normalizeMonthlyDateRange(startDate, endDateToSet).start
            : normalizeYearlyDateRange(startYearDate, endDateToSet).start;
        fetchPalCodesData(activeStart, endDateToSet, processedFilesCheckbox);
        fetchBalanceControl(activeStart, endDateToSet, processedFilesCheckbox);
        await fetchTrialBalanceData(activeStart, endDateToSet, processedFilesCheckbox, true);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        let startDateToSet;

        if (type === 'year') {
            updatedDate = toUtcMonthStart(newDate.getFullYear(), getUtcMonthSafe(startDate, 0));
        } else if (type === 'month') {
            updatedDate = toUtcMonthStart(getUtcFullYearSafe(startDate), newDate.getMonth());
        }

        if (isMonthly) {
            startDateToSet = updatedDate;
            dispatch(setStartDate(updatedDate));
        } else {
            startDateToSet = toUtcYearStart(newDate.getFullYear());
            dispatch(setStartYearDate(startDateToSet));
            dispatch(setStartDate(startDateToSet));
        }

        const activeEnd = isMonthly
            ? normalizeMonthlyDateRange(startDateToSet, endDate).end
            : normalizeYearlyDateRange(startDateToSet, endYearDate).end;
        fetchPalCodesData(startDateToSet, activeEnd, processedFilesCheckbox);
        fetchBalanceControl(startDateToSet, activeEnd, processedFilesCheckbox);
        await fetchTrialBalanceData(startDateToSet, activeEnd, processedFilesCheckbox, true);
    };


    const [selectedSearchType, setSelectedSearchType] = useState('General');
    const [showWithZeros, setShowWithZeros] = useState(false);


    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
    const filteredAndSortedPalCodesData = useMemo(() => {
        if (!palCodesData || palCodesData.length === 0) {
            return [];
        }
        let filteredData;

        if (selectedSearchType === 'General') {
            filteredData = palCodesData.filter((palCode) => {
                const query = debouncedSearchQuery.toLowerCase();

                return palCode.accountCards.some(accountCard => {
                    const amountString = accountCard.dateAmounts.map(dateAmount => dateAmount.amount?.toString()).join(' ');
                    return (
                        palCode?.palCodeId?.toLowerCase().includes(query) ||
                        accountCard?.name?.toLowerCase().includes(query) ||
                        amountString.includes(query) ||
                        accountCard.dateAmounts.some(dateAmount =>
                            dateAmount.date?.toLowerCase().includes(query) ||
                            dateAmount.amount?.toString().includes(query)
                        )
                    );
                });
            });
        }

        if (selectedSearchType === 'BalanceClassificationMazni') {
            filteredData = palCodesData.filter((palCode) => {
                const query = debouncedSearchQuery.toLowerCase();

                return (
                    palCode?.palCodeId?.toLowerCase().includes(query)
                );
            });
        }

        if (selectedSearchType === 'AccountCard') {
            filteredData = palCodesData
                .map((palCode) => {
                    const query = debouncedSearchQuery.toLowerCase();

                    // Filter accountCards within each palCode
                    const filteredAccountCards = palCode.accountCards.filter(accountCard =>
                        accountCard?.name?.toLowerCase().includes(query)
                    );

                    // If there are matching accountCards, return the palCode with those filtered accountCards
                    if (filteredAccountCards.length > 0) {
                        return {
                            ...palCode,
                            accountCards: filteredAccountCards
                        };
                    }

                    // If no accountCards match, return null (to filter out later)
                    return null;
                })
                .filter(palCode => palCode !== null); // Remove palCodes without matching accountCards
        }

        if (!showWithZeros) {
            filteredData = filteredData.filter(palCode => {
                return palCode.accountCards.some(accountCard =>
                    accountCard.dateAmounts.some(dateAmount => dateAmount.amount !== 0)
                );
            });
        }

        // Sorting the filtered data based on sortConfig
        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const aValue = a[sortConfig.key] || "";
                    const bValue = b[sortConfig.key] || "";

                    return sortConfig.direction === 'ascending'
                        ? new Date(aValue) - new Date(bValue)
                        : new Date(bValue) - new Date(aValue);
                } else if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending'
                        ? a[sortConfig.key] - b[sortConfig.key]
                        : b[sortConfig.key] - a[sortConfig.key];
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending'
                        ? new Date(a[sortConfig.key]) - new Date(b[sortConfig.key])
                        : new Date(b[sortConfig.key]) - new Date(a[sortConfig.key]);
                } else {
                    const aValue = a[sortConfig.key]?.toLowerCase() || "";
                    const bValue = b[sortConfig.key]?.toLowerCase() || "";

                    return sortConfig.direction === 'ascending'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                }
            });
        }

        return filteredData;
    }, [palCodesData, debouncedSearchQuery, sortConfig, selectedSearchType, showWithZeros]);

    // Debounce logic
    const debouncedSetSearchQuery = useCallback(
        debounce((query) => setDebouncedSearchQuery(query), 500),
        []
    );

    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query); // Immediate UI update
        debouncedSetSearchQuery(query); // Debounced logic
    };

    const fetchPalCodesData = (
        startDate,
        endDate,
        onlyProcessed = true,
        forceRefresh = false
    ) => {

        return new Promise(async (resolve) => {
            try {
                if (!client) return resolve();

                const state = store.getState().ledgerReportSlice;
                const currentPalCodes = state.palCodesData;
                const lastStart = state.lastFetchStartDate ? new Date(state.lastFetchStartDate) : null;
                const lastEnd = state.lastFetchEndDate ? new Date(state.lastFetchEndDate) : null;

                const isSameRange =
                    lastStart?.toISOString() === startDate?.toISOString() &&
                    lastEnd?.toISOString() === endDate?.toISOString();

                // if (!forceRefresh && isSameRange && currentPalCodes?.length > 0) {
                // //   return resolve(); // no need to re-fetch
                // }

                const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                    ? endDate
                    : new Date(Date.UTC(startDate.getFullYear(), 11, 31));

                let requestStart = startDate;
                let requestEnd = finalEndDate;

                if (isMonthly) {
                    const normalized = normalizeMonthlyDateRange(startDate, finalEndDate);
                    requestStart = normalized.start;
                    requestEnd = normalized.end;
                    dispatch(setStartDate(normalized.start));
                    dispatch(setEndDate(normalized.end));
                    dispatch(setLastFetchDates({ startDate: normalized.start, endDate: normalized.end }));
                } else {
                    const normalized = normalizeYearlyDateRange(startDate, finalEndDate);
                    requestStart = normalized.start;
                    requestEnd = normalized.end;
                    dispatch(setStartYearDate(normalized.start));
                    dispatch(setEndYearDate(normalized.end));
                }

                const response = await ReportsService.GetPalCodesDetails(
                    client.caseId,
                    client.accountantId,
                    requestStart,
                    requestEnd,
                    !isMonthly,
                    token,
                    onlyProcessed,
                    isProfitAndLoss,
                    filterByDocumentDateRef.current
                );

                if (!response.ok) {
                    const errorText = await response.text();
                    toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${errorText}`);
                    return resolve();
                }

                const responseJson = await response.json();
                const result = responseJson.palCodes;

                dispatch(setPalCodesData({ palCodesData: result }));

                const dates = new Set();
                result.forEach(palCode => {
                    palCode.accountCards.forEach(accountCard => {
                        accountCard.dateAmounts.forEach(dateAmount => {
                            dates.add(dateAmount.date);
                        });
                    });
                });

                const sortedDates = Array.from(dates).sort((a, b) => new Date(a) - new Date(b));
                dispatch(setPalDates(sortedDates));

                resolve();
            } catch (error) {
                console.error("Error in PAL API call:", error);
                toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${error.message}`);
                resolve();
            }
        });
    };

    const fetchBalanceControl = async (
        startDate,
        endDate,
        onlyProcessed = true,
        forceRefresh = false
    ) => {
        try {
            if (!client) return;

            const state = store.getState().ledgerReportSlice;
            const currentBalanceControl = state.balanceControl;
            const lastStart = state.lastFetchStartDate ? new Date(state.lastFetchStartDate) : null;
            const lastEnd = state.lastFetchEndDate ? new Date(state.lastFetchEndDate) : null;

            const isSameRange =
                lastStart?.toISOString() === startDate?.toISOString() &&
                lastEnd?.toISOString() === endDate?.toISOString();

            //   if (!forceRefresh && isSameRange && currentBalanceControl?.length > 0) return;

            const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                ? endDate
                : new Date(Date.UTC(startDate.getFullYear(), 11, 31));

            let requestStart = startDate;
            let requestEnd = finalEndDate;

            if (isMonthly) {
                const normalized = normalizeMonthlyDateRange(startDate, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
                dispatch(setStartDate(normalized.start));
                dispatch(setEndDate(normalized.end));
                dispatch(setLastFetchDates({ startDate: normalized.start, endDate: normalized.end }));
            } else {
                const normalized = normalizeYearlyDateRange(startDate, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
                dispatch(setStartYearDate(normalized.start));
                dispatch(setEndYearDate(normalized.end));
            }

            const response = await DocumentService.BalanceControl(
                client.caseId,
                requestStart,
                requestEnd,
                token,
                false,
                true // Default to registration month
            );

            if (response.ok) {
                const responseJson = await response.json();
                dispatch(setBalanceControl(responseJson));
            } else {
                const errorText = await response.text();
                toast.error(`${t('ErrorFetchingBalanceControl')}: ${errorText}`);
            }
        } catch (error) {
            console.error("Error in API call:", error);
            toast.error(`${t('ErrorFetchingBalanceControl')}: ${error.message}`);
        } finally {
            dispatch(setLoading(false));
        }
    };



    const lastTrialBalanceFilterKeyRef = useRef('none');
    /** Trial Balance fetch range cache — independent from PalCodes/BalanceControl lastFetchDates */
    const lastTrialBalanceFetchRangeRef = useRef({ start: null, end: null });
    const fetchTrialBalanceDataRef = useRef(null);
    /** Mirrors selectedCurrency so the fetch reads the latest selection without being rebuilt. */
    const selectedCurrencyRef = useRef(null);
    /** Mirrors processedFilesCheckbox; declared early so callbacks above that state stay valid. */
    const processedFilesForTrialBalanceRef = useRef(true);
    /**
     * When Trial Balance is in "Projects" mode, refetch (e.g. date change) must keep the same segmentation filter.
     * Updated synchronously in handleTrialBalanceSegmentationFilterChange; read in fetchTrialBalanceData when no explicit filter is passed.
     */
    const trialBalanceSegmentationFilterRef = useRef(null);
    const profitAndLossSegmentationFilterRef = useRef(null);

    const fetchTrialBalanceData = async (
        startDate,
        endDate,
        onlyProcessed = true,
        forceRefresh = false,
        explicitTrialBalanceFilter = undefined
    ) => {
        dispatch(setLoading(true));

        try {
            if (!client) {
                dispatch(setLoading(false));
                return;
            }

            const state = store.getState().ledgerReportSlice;
            const trialBalance = state.trialBalanceData;

            const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                ? endDate
                : new Date(Date.UTC(startDate.getFullYear(), 11, 31));

            const trialBalanceFilterResolved =
                explicitTrialBalanceFilter !== undefined
                    ? explicitTrialBalanceFilter
                    : isProfitAndLoss
                        ? profitAndLossSegmentationFilterRef.current
                        : trialBalanceSegmentationFilterRef.current;

            // Foreign-currency selection drives a server-side recompute, so include it in the cache key.
            const currencySelection = selectedCurrencyRef.current;
            const currencyFilterParam = typeof currencySelection === 'number' ? currencySelection : null;
            const includeForeignCurrencyParam = currencySelection === 'MIXED';

            const baseFilterKey =
                trialBalanceFilterResolved && trialBalanceFilterResolved.trialBalanceType === 'Projects'
                    ? `Projects|${trialBalanceFilterResolved.fromSegmentationId ?? ''}|${trialBalanceFilterResolved.toSegmentationId ?? ''}`
                    : 'none';
            const filterKey = `${baseFilterKey}|cur:${currencySelection ?? 'ILS'}|byDoc:${filterByDocumentDateRef.current}`;

            const lastTbRange = lastTrialBalanceFetchRangeRef.current;
            const isSameTrialBalanceRange =
                lastTbRange.start &&
                lastTbRange.end &&
                lastTbRange.start.toISOString() === startDate?.toISOString() &&
                lastTbRange.end.toISOString() === finalEndDate.toISOString();

            if (
                !forceRefresh &&
                isSameTrialBalanceRange &&
                trialBalance &&
                trialBalance.clientCase === client.caseId &&
                lastTrialBalanceFilterKeyRef.current === filterKey
            ) {
                dispatch(setLoading(false));
                return;
            }

            let requestStart = startDate;
            let requestEnd = finalEndDate;

            if (isMonthly) {
                const normalized = normalizeMonthlyDateRange(startDate, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
                dispatch(setStartDate(normalized.start));
                dispatch(setEndDate(normalized.end));
                dispatch(setLastFetchDates({ startDate: normalized.start, endDate: normalized.end }));
            } else {
                const normalized = normalizeYearlyDateRange(startDate, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
                dispatch(setStartYearDate(normalized.start));
                dispatch(setEndYearDate(normalized.end));
            }

            const response = await ReportsService.GetTrialBalanceDetails(
                client.caseId,
                client.accountantId,
                requestStart,
                requestEnd,
                !isMonthly,
                token,
                onlyProcessed,
                isProfitAndLoss,
                trialBalanceFilterResolved && trialBalanceFilterResolved.trialBalanceType === 'Projects'
                    ? trialBalanceFilterResolved
                    : null,
                filterByDocumentDateRef.current,
                currencyFilterParam,
                includeForeignCurrencyParam
            );

            if (!response.ok) {
                const errorText = await response.text();
                toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${errorText}`);
            } else {
                const responseJson = await response.json();
                if (responseJson && typeof responseJson === 'object') {
                    dispatch(setTrialBalanceData(responseJson));
                    setAvailableCurrencies(Array.isArray(responseJson.availableCurrencies) ? responseJson.availableCurrencies : []);
                    lastTrialBalanceFilterKeyRef.current = filterKey;
                    lastTrialBalanceFetchRangeRef.current = { start: requestStart, end: requestEnd };
                }
            }
        } catch (error) {
            console.error("Error in API call:", error);
            toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${error.message}`);
        } finally {
            dispatch(setLoading(false));
        }
    };
    fetchTrialBalanceDataRef.current = fetchTrialBalanceData;

    // Currency selector for the HTML reports: refetch so the backend recomputes FC columns.
    const handleReportCurrencyChange = useCallback(async (nextCurrency) => {
        const normalized = nextCurrency === undefined ? null : nextCurrency;
        selectedCurrencyRef.current = normalized;
        setSelectedCurrency(normalized);
        if (!fetchTrialBalanceDataRef.current) return;
        const start = isMonthly ? startDate : startYearDate;
        const end = isMonthly ? endDate : endYearDate;
        await fetchTrialBalanceDataRef.current(
            start,
            end,
            processedFilesForTrialBalanceRef.current,
            true
        );
    }, [isMonthly, startDate, endDate, startYearDate, endYearDate]);

    const handleTrialBalanceSegmentationFilterChange = useCallback(async (trialBalanceFilter) => {
        if (!fetchTrialBalanceDataRef.current) return;
        const normalized =
            client?.managesProject && trialBalanceFilter && trialBalanceFilter.trialBalanceType === 'Projects'
                ? trialBalanceFilter
                : null;
        trialBalanceSegmentationFilterRef.current = normalized;
        const start = isMonthly ? startDate : startYearDate;
        const end = isMonthly ? endDate : endYearDate;
        await fetchTrialBalanceDataRef.current(
            start,
            end,
            processedFilesForTrialBalanceRef.current,
            true,
            normalized
        );
    }, [isMonthly, startDate, endDate, startYearDate, endYearDate, client]);

    const handleProfitAndLossSegmentationFilterChange = useCallback(async (trialBalanceFilter) => {
        if (!fetchTrialBalanceDataRef.current) return;
        const normalized =
            client?.managesProject && trialBalanceFilter && trialBalanceFilter.trialBalanceType === 'Projects'
                ? trialBalanceFilter
                : null;
        profitAndLossSegmentationFilterRef.current = normalized;
        const start = isMonthly ? startDate : startYearDate;
        const end = isMonthly ? endDate : endYearDate;
        await fetchTrialBalanceDataRef.current(
            start,
            end,
            processedFilesForTrialBalanceRef.current,
            true,
            normalized
        );
    }, [isMonthly, startDate, endDate, startYearDate, endYearDate, client]);




    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input document-custom-input-range `} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));


    const { hasBack, handleBack } = useBack();

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // handleBack();
            goBack()
        }
    };

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        setClient(location.state.client);
                        setType(location.state.type);
                        setIsProfitAndLoss(location.state.isProfitAndLoss);
                        if (isDataFetched) {

                            await refreshData();
                        }
                        else {

                            setIsDataFetched(true);
                        }
                    }
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }

            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };

        fetchUserData();

    }, [location.state]);

    useEffect(() => {
        if (isDataFetched) {
            const storedStartDateString = localStorage.getItem('StartDate');
            const storedEndDateString = localStorage.getItem('EndDate');
            const storedStartYearDateString = localStorage.getItem('StartYearDate');
            const storedEndYearDateString = localStorage.getItem('EndYearDate');

            const startDateRaw = storedStartDateString ? new Date(storedStartDateString) : getStartOfYear(new Date());
            const endDateRaw = storedEndDateString ? new Date(storedEndDateString) : getCurrentMonth(new Date());
            // Day=10 placeholders (and similar) → real month bounds before first fetch.
            const { start: startDate, end: endDate } = normalizeMonthlyDateRange(startDateRaw, endDateRaw);
            // CustomYearDatePicker / other pages may have stored Dec 31 as StartYearDate — normalize.
            const { start: startYearDate, end: endYearDate } = normalizeYearlyDateRange(
                storedStartYearDateString ? new Date(storedStartYearDateString) : toUtcYearStart(startDate.getUTCFullYear()),
                storedEndYearDateString ? new Date(storedEndYearDateString) : toUtcYearEnd(endDate.getUTCFullYear())
            );

            dispatch(setStartDate(startDate));
            dispatch(setEndDate(endDate));
            dispatch(setStartYearDate(startYearDate));
            dispatch(setEndYearDate(endYearDate));

            const activeStartDate = isMonthly ? startDate : startYearDate;
            const activeEndDate = isMonthly ? endDate : endYearDate;

            fetchPalCodesData(activeStartDate, activeEndDate, processedFilesCheckbox, true);
            fetchBalanceControl(activeStartDate, activeEndDate, processedFilesCheckbox, true);
            fetchTrialBalanceData(activeStartDate, activeEndDate, processedFilesCheckbox, true);
            fetchEnums(token, client);
        }
    }, [isDataFetched]);


    useEffect(() => {
        if (client) {
            refreshData();
        }

    }, [isMonthly]);



    const refreshData = async () => {
        if (!client || !token) return;

        await fetchEnums(token, client);

        let start;
        let end;
        if (isMonthly) {
            const normalized = normalizeMonthlyDateRange(startDate, endDate);
            start = normalized.start;
            end = normalized.end;
            dispatch(setStartDate(start));
            dispatch(setEndDate(end));
        } else {
            const normalized = normalizeYearlyDateRange(startYearDate, endYearDate);
            start = normalized.start;
            end = normalized.end;
            // Keep Redux / pickers in sync with the range we actually fetch.
            dispatch(setStartYearDate(start));
            dispatch(setEndYearDate(end));
        }

        await Promise.all([
            fetchPalCodesData(start, end, processedFilesCheckbox, true),
            fetchTrialBalanceData(start, end, processedFilesCheckbox, true),
            fetchBalanceControl(start, end, processedFilesCheckbox, true),
        ]);
    };



    const Row = ({ palCode, dateHeaders, open, handleToggleRow, onRightClick }) => {
        // High-level total sum for the palCode (sum of all accountCards)
        const palCodeTotal = palCode.accountCards.reduce((sum, accountCard) => {
            return sum + accountCard.dateAmounts.reduce((acc, dateAmount) => acc + (dateAmount ? dateAmount.amount : 0), 0);
        }, 0);
        return (
            <>
                <TableRow sx={{
                    transition: 'background-color 0.2s ease-in-out', // Smooth transition for background color
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Slightly change the background color on hover
                        cursor: 'pointer', // Change cursor to pointer
                    }
                }}>
                    {/* High-level sum (total sum of the palCode row) */}
                    <TableCell align="left" style={{ color: 'color', fontWeight: 'bold' }}>
                        {beautifyNumber(palCodeTotal)}
                    </TableCell>
                    {[...dateHeaders].reverse().map(date => (
                        <TableCell key={date} align="left">
                            {beautifyNumber(palCode.accountCards.reduce((sum, accountCard) => {
                                const dateAmount = accountCard.dateAmounts.find(da => da.date === date);
                                return sum + (dateAmount ? dateAmount.amount : 0);
                            }, 0))}
                        </TableCell>
                    ))}
                    {/* Last cell for the sum of the row */}
                    <TableCell
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'left',
                            fontSize: '0.8rem',  // Adjust the font size as needed
                            fontWeight: 'bold'    // Optionally make the font bold
                        }}
                    >
                        <TableCell>
                            {palCode.palCodeId === "NonPalCode" ? t(palCode.palCodeId) : palCode.palCodeId}
                        </TableCell>
                        {open ? (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={handleToggleRow}
                            >
                                <KeyboardArrowUp />
                            </IconButton>
                        ) : (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={handleToggleRow}
                            >
                                <KeyboardArrowDown />
                            </IconButton>
                        )}
                    </TableCell>

                </TableRow>

                {(open || (selectedSearchType === 'AccountCard' && debouncedSearchQuery)) && (
                    palCode.accountCards.map((accountCard, index) => {
                        // Low-level total sum for each accountCard
                        const accountCardTotal = accountCard.dateAmounts.reduce((sum, dateAmount) => sum + (dateAmount ? dateAmount.amount : 0), 0);

                        return (
                            <TableRow onClick={() => handleSelect(accountCard, palCode)}
                                onContextMenu={(e) => {
                                    e.preventDefault(); // Prevent the default right-click menu
                                    onRightClick(accountCard, palCode); // Trigger right-click handler
                                }}
                                className='open-rows rowHover'
                                sx={{
                                    ...{ boxShadow: 'inset 0px 2px 200px 0px rgba(250, 235, 215, 0.2)' },
                                    transition: 'transform 0.2s ease, box-shadow 0.1s ease', '&:hover': { transform: 'translateY(-3px)', cursor: 'pointer' }
                                }}
                                key={index}
                            >
                                {/* Low-level sum (total sum of the accountCard row) */}
                                <TableCell align="left" style={{ color: 'color', fontWeight: 'bold' }}>
                                    {beautifyNumber(accountCardTotal)}
                                </TableCell>
                                {[...dateHeaders].reverse().map(date => (
                                    <TableCell key={date} align="left">
                                        {beautifyNumber(accountCard.dateAmounts.find(da => da.date === date)?.amount) || 0}
                                    </TableCell>
                                ))}
                                <TableCell component="th" scope="row">
                                    {accountCard.name}
                                </TableCell>

                            </TableRow>
                        );
                    })
                )}
            </>
        );
    };


    const handleToggleRow = (index) => {
        setOpenRows(prevState => ({ ...prevState, [index]: !prevState[index] }));
    };

    const [addAccountCardType, setAddAccountCardType] = useState('main');
    const [editedAccountCard, setEditedAccountCard] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedAccountCard, setSelectedAccountCard] = useState(null);
    const [selectedAccountCardPalCode, setSelectedAccountCardPalCode] = useState(null);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [isEditAccountCard, setIsEditAccountCard] = useState(false);


    const handleCloseItem = () => {
        setPalCode('');
        setEditedAddAccountCard(false);
        // Reset editedAccountCard to ensure clean state for next open
        setEditedAccountCard({});
        setSelectedAccountCard(null);
    };
    // Step 2: Handle right-click and open the dialog
    const handleRightClickedRow = (accountCard, palCode) => {
        const accountCardWithPalCode = { ...accountCard, palCodeId: palCode.palCodeId };
        setSelectedAccountCard(accountCardWithPalCode);
        setPalCode(palCode.palCodeId);
        setSelectedAccountCardPalCode(accountCardWithPalCode.palCodeId);
        // Set editedAccountCard immediately to ensure modal has data when it opens
        const foundCard = accountCardOptions.find(card => card.cardId === accountCard.cardId);
        if (foundCard) {
            setEditedAccountCard({ ...foundCard, palCodeId: palCode.palCodeId });
        } else {
            // Fallback: use the accountCard data directly if not found in options
            setEditedAccountCard(accountCardWithPalCode);
        }
        setOpenDialog(true);  // Open the dialog
        setEditedAddAccountCard(true);
    };

    // Step 3: Handle closing the dialog
    const handleCloseDialog = () => {
        setOpenDialog(false);  // Close the dialog
        setSelectedAccountCard(null);  // Reset the selected account card
    };



    const calculateFooterTotals = (filteredPalCodes, dateHeaders) => {
        const totals = {
            grandTotal: 0,
            dateTotals: dateHeaders.reduce((acc, date) => {
                acc[date] = 0;
                return acc;
            }, {})
        };

        filteredPalCodes.forEach(palCode => {
            const palCodeTotal = palCode.accountCards.reduce((sum, accountCard) => {
                return sum + accountCard.dateAmounts.reduce((acc, dateAmount) => acc + (dateAmount ? dateAmount.amount : 0), 0);
            }, 0);

            totals.grandTotal += palCodeTotal;

            dateHeaders.forEach(date => {
                const dateTotal = palCode.accountCards.reduce((sum, accountCard) => {
                    const dateAmount = accountCard.dateAmounts.find(da => da.date === date);
                    return sum + (dateAmount ? dateAmount.amount : 0);
                }, 0);
                totals.dateTotals[date] += dateTotal;
            });
        });

        return totals;
    };
    const footerTotals = calculateFooterTotals(filteredAndSortedPalCodesData, palDates);

    const handleOpenHTMLModal = async () => {
        setOpenReportModal(true);
    };
    const handleOpenProfitAndLossReportHtml = async () => {
        setOpenProfitAndLossModal(true);
    };

    const handleOpenMatchingProfitAndLossReport = async () => {
        // Extract year from startYearDate or endYearDate using UTC to ensure correct year extraction
        let year;
        if (startYearDate && endYearDate) {
            const startYearDateObj = dayjs.utc(startYearDate);
            const endYearDateObj = dayjs.utc(endYearDate);
            const StartYear = startYearDateObj.year();
            const EndYear = endYearDateObj.year();
            if (StartYear !== EndYear) {
                
                toast.info(t('YearAdjustedToMatch') || `End date adjusted to the same year (${StartYear})`);
                return; // Prevent opening preview - user needs to click again after adjustment
            }
            // Use the year from startYearDate (both should be the same at this point)
            year = StartYear;
        } else {
            // Fallback: extract year from startDate or endDate using UTC
            if (startDate) {
                year = dayjs.utc(startDate).year();
            } else if (endDate) {
                year = dayjs.utc(endDate).year();
            } else {
                year = dayjs.utc().year();
            }
        }
        setProfitAndLossYear(year);
        // Default: show cards ON, percentages ON
        setMatchingShowCards(true);
        setMatchingShowPercentageColumn(true);
        setOpenMatchingProfitAndLossModal(true);
    };

    const handleCloseMatchingProfitAndLossModal = () => {
        setOpenMatchingProfitAndLossModal(false);
    };

    const handleOpenEditableProfitAndLossReport = () => {
        setOpenEditableProfitAndLossModal(true);
    };

    const handleCloseEditableProfitAndLossReport = () => {
        setOpenEditableProfitAndLossModal(false);
        setEditableProfitAndLossHtmlContent('');
        setEditableShowPercentageColumn(false);
    };

    const handleEditableProfitAndLossHtmlContentChange = (htmlContent) => {
        setEditableProfitAndLossHtmlContent(htmlContent);
    };

    // Callback to receive HTML content from ProfitAndLossReportHtml
    const handleProfitAndLossHtmlContentChange = (htmlContent) => {
        setProfitAndLossHtmlContent(htmlContent);
    };

    // Callback to receive profitAndLossTotalBalance1 from ProfitAndLossReportHtml
    const handleProfitAndLossTotalChange = (totalBalance) => {
        setProfitAndLossTotalBalance(totalBalance);
    };

    // Callback to regenerate HTML when checkboxes change in matching modal
    const handleRegenerateMatchingHtml = (showCards, showPercentageColumn) => {
        // This will trigger ProfitAndLossReportHtml to regenerate with new flags
        // The HTML will be updated via handleProfitAndLossHtmlContentChange
        setMatchingShowCards(showCards);
        setMatchingShowPercentageColumn(showPercentageColumn);
    };
    const handleOpenBalanceControlModal = async () => {
        setOpenBalanceControlModal(true);
    };

    const handleCloseBalanceControlDialog = async () => {
        setOpenBalanceControlModal(false);
    };

    const fetchPalcodePlacement = async (startDateArg, endDateArg, onlyProcessed = true) => {
        try {
            if (!client) return;

            const finalEndDate = endDateArg instanceof Date && !isNaN(endDateArg)
                ? endDateArg
                : new Date(Date.UTC(startDateArg.getFullYear(), 11, 31));

            let requestStart = startDateArg;
            let requestEnd = finalEndDate;

            if (isMonthly) {
                const normalized = normalizeMonthlyDateRange(startDateArg, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
            } else {
                const normalized = normalizeYearlyDateRange(startDateArg, finalEndDate);
                requestStart = normalized.start;
                requestEnd = normalized.end;
            }

            const response = await DocumentService.VatPalcodePlacementControl(
                client.caseId,
                requestStart,
                requestEnd,
                token,
                onlyProcessed,
                true // registration month
            );

            if (response.ok) {
                const responseJson = await response.json();
                dispatch(setPalcodePlacementViolations(responseJson));
            } else {
                const errorText = await response.text();
                toast.error(`${t('ErrorFetchingPalcodePlacementCheck')}: ${errorText}`);
            }
        } catch (error) {
            console.error("Error in VatPalcodePlacementControl API call:", error);
            toast.error(`${t('ErrorFetchingPalcodePlacementCheck')}: ${error.message}`);
        }
    };

    const handleOpenPalcodeCheckModal = async (checkType) => {
        setPalcodeCheckType(checkType);
        const activeStartDate = isMonthly ? startDate : startYearDate;
        const activeEndDate = isMonthly ? endDate : endYearDate;
        await fetchPalcodePlacement(activeStartDate, activeEndDate, processedFilesCheckbox);
    };

    const handleClosePalcodePlacementDialog = async () => {
        setPalcodeCheckType(null);
    };

    const handleCloseHTMLModal = () => {
        setOpenReportModal(false);
    };

    const handleCloseProfitAndLossReportHtml = () => {
        setOpenProfitAndLossModal(false);
    };

    const handleChange = (event) => {
        const { name } = event.target;
        setSelectedSearchType(name);

    };

    const [alignment, setAlignment] = React.useState('left')

    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
    };


    const [processedFilesCheckbox, setProcessedFilesCheckbox] = useState(() => {
        const savedValue = localStorage.getItem('processedFilesCheckbox');
        return savedValue === null ? true : JSON.parse(savedValue);
    });
    processedFilesForTrialBalanceRef.current = processedFilesCheckbox;

    // Update localStorage whenever the checkbox value changes
    useEffect(() => {
        localStorage.setItem('processedFilesCheckbox', JSON.stringify(processedFilesCheckbox));
    }, [processedFilesCheckbox]);

    const handleProcessFilesCheckboxClick = async (isChecked) => {

        try {
            if (isChecked !== null) {
                const activeStartDate = isMonthly ? startDate : startYearDate;
                const activeEndDate = isMonthly ? endDate : endYearDate;
                // `isChecked` is the new value of processedFilesCheckbox (passed as !processedFilesCheckbox
                // from the toggle). Every other fetch passes processedFilesCheckbox directly as the
                // onlyProcessed argument, so this must match to avoid inverting the toggle.
                const onlyProcessed = isChecked;

                try {
                    await fetchPalCodesData(activeStartDate, activeEndDate, onlyProcessed, true);
                    await fetchBalanceControl(activeStartDate, activeEndDate, onlyProcessed, true);
                    await fetchTrialBalanceData(activeStartDate, activeEndDate, onlyProcessed, true);
                } catch (error) {
                    toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${error.message}`);
                }
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
        }

        setProcessedFilesCheckbox(isChecked);
    };

    const handleDateBasisChange = async (byDocumentDate) => {
        if (byDocumentDate === filterByDocumentDate) return;

        filterByDocumentDateRef.current = byDocumentDate;
        setFilterByDocumentDate(byDocumentDate);
        localStorage.setItem('ledgerReportFilterByDocumentDate', byDocumentDate);

        if (!client) return;

        const activeStartDate = isMonthly ? startDate : startYearDate;
        const activeEndDate = isMonthly ? endDate : endYearDate;
        if (!activeStartDate || !activeEndDate) return;

        try {
            await Promise.all([
                fetchPalCodesData(activeStartDate, activeEndDate, processedFilesCheckbox, true),
                fetchTrialBalanceData(activeStartDate, activeEndDate, processedFilesCheckbox, true),
            ]);
        } catch (error) {
            toast.error(`${t('ErrorFetchingLedgerReportDetails')}: ${error.message}`);
        }
    };


    const memoizedTrialBalanceReport = useMemo(() => {
        if (client && trialBalanceData) {

            return (
                <TrialBalanceReportHtml
                    open={openReportModal}
                    handleClose={handleCloseHTMLModal}
                    data={trialBalanceData}
                    handleSelect={handleSelect}
                    token={token}
                    client={client}  // Only pass client when it's not null
                    showAccountCardsWithZeros={showAccountCardsWithZeros}
                    setShowAccountCardsWithZeros={setShowAccountCardsWithZeros}
                    palCodesData={palCodesData}
                    palDates={palDates}
                    isMonthly={isMonthly}
                    userTypeContext={userTypeContext}
                    onTrialBalanceSegmentationFilterChange={handleTrialBalanceSegmentationFilterChange}
                    selectedCurrency={selectedCurrency}
                    availableCurrencies={availableCurrencies}
                    onCurrencyChange={handleReportCurrencyChange}
                />
            );
        }
        return null;  // Return null if client is null to avoid rendering
    }, [client, trialBalanceData, openReportModal, token, handleSelect, showAccountCardsWithZeros, palCodesData, palDates, isMonthly, handleTrialBalanceSegmentationFilterChange, selectedCurrency, availableCurrencies, handleReportCurrencyChange]);


    const memoizedProfitAndLossReport = useMemo(() => {
        if (client && trialBalanceData) {

            return (
                <ProfitAndLossReportHtml
                    open={openProfitAndLossModal}
                    handleClose={handleCloseProfitAndLossReportHtml}
                    data={trialBalanceData}
                    handleSelect={handleSelect}
                    token={token}
                    client={client}  // Only pass client when it's not null
                    showAccountCardsWithZeros={showAccountCardsWithZeros}
                    setShowAccountCardsWithZeros={setShowAccountCardsWithZeros}
                    // Additional props for MonthlyReportModal
                    palCodesData={palCodesData}
                    palDates={palDates}
                    onTrialBalanceSegmentationFilterChange={handleProfitAndLossSegmentationFilterChange}
                    selectedCurrency={selectedCurrency}
                    availableCurrencies={availableCurrencies}
                    onCurrencyChange={handleReportCurrencyChange}
                />
            );
        }
        return null;  // Return null if client is null to avoid rendering
    }, [client, trialBalanceData, openReportModal, token, handleSelect, openProfitAndLossModal, showAccountCardsWithZeros, palCodesData, palDates, handleProfitAndLossSegmentationFilterChange, selectedCurrency, availableCurrencies, handleReportCurrencyChange]);

    // Separate hidden component for matching modal HTML generation (with default values)
    const memoizedMatchingHtmlGenerator = useMemo(() => {
        if (client && trialBalanceData && openMatchingProfitAndLossModal) {
            return (
                <ProfitAndLossReportHtml
                    open={false} // Hidden - just for HTML generation
                    handleClose={() => {}}
                    data={trialBalanceData}
                    handleSelect={handleSelect}
                    token={token}
                    client={client}
                    showAccountCardsWithZeros={showAccountCardsWithZeros}
                    setShowAccountCardsWithZeros={setShowAccountCardsWithZeros}
                    palCodesData={palCodesData}
                    palDates={palDates}
                    onHtmlContentChange={handleProfitAndLossHtmlContentChange}
                    onProfitAndLossTotalChange={handleProfitAndLossTotalChange}
                    // Use default values: ShowCards=true, ShowPercentageColumn=false (matching ReportToolbar defaults)
                    externalShowCards={matchingShowCards}
                    externalShowPercentageColumn={matchingShowPercentageColumn}
                    isMatchingReport
                />
            );
        }
        return null;
    }, [client, trialBalanceData, openMatchingProfitAndLossModal, token, handleSelect, showAccountCardsWithZeros, palCodesData, palDates, matchingShowCards, matchingShowPercentageColumn]);

    const memoizedEditableHtmlGenerator = useMemo(() => {
        if (client && trialBalanceData && openEditableProfitAndLossModal) {
            return (
                <ProfitAndLossReportHtml
                    open={false}
                    handleClose={() => {}}
                    data={trialBalanceData}
                    handleSelect={handleSelect}
                    token={token}
                    client={client}
                    showAccountCardsWithZeros={showAccountCardsWithZeros}
                    setShowAccountCardsWithZeros={setShowAccountCardsWithZeros}
                    palCodesData={palCodesData}
                    palDates={palDates}
                    onHtmlContentChange={handleEditableProfitAndLossHtmlContentChange}
                    externalShowCards={true}
                    externalShowPercentageColumn={editableShowPercentageColumn}
                />
            );
        }
        return null;
    }, [client, trialBalanceData, openEditableProfitAndLossModal, token, handleSelect, showAccountCardsWithZeros, palCodesData, palDates, editableShowPercentageColumn]);

    const updateAccountCardPalCode = async (updatedAccountCard, oldCard) => {

        try {
            // Ensure empty string fields are converted to null
            Object.entries(updatedAccountCard).forEach(([key, value]) => {
                if (value === '') {
                    updatedAccountCard[key] = null;
                }
            });


            // Handle special cases for sourceDeductionAssociation and palCode
            if (updatedAccountCard.sourceDeductionAssociation && typeof updatedAccountCard.sourceDeduction === 'object' && 'key' in updatedAccountCard.sourceDeduction) {
                updatedAccountCard.sourceDeductionAssociation = updatedAccountCard.sourceDeduction['key'];
            }

            if (updatedAccountCard.palCode && typeof updatedAccountCard.palCode === 'object' && 'key' in updatedAccountCard.palCode) {
                updatedAccountCard.palCode = updatedAccountCard.palCode['key'];
            }

            const sourceDeductionAssociationAsNum = updatedAccountCard.sourceDeductionAssociation === 'NotIncluded' ? 0 : 1;

            // Call the API to update the account card
            const response = await EnumsService.UpdateAccountCardFewDetails(
                client.caseId,
                oldCard.cardId,
                oldCard.name,
                oldCard.cardId,
                updatedAccountCard.name,
                oldCard.accountCaseId,
                '', //account case id
                updatedAccountCard.palCodeId,
                token,
            );
            if (response.ok) {
                refreshData();
                toast.success(t('AccountCardUpdated'));

            } else {

                const errorText = await response.text();
                console.error('FailedToUpdateAccountCard', errorText);
                toast.error(t('FailedToUpdateAccountCard'));
            }
        } catch (error) {
            console.error('Error saving account card:', t(error));
            if (error == 'Card Not Editable') {
                toast.error(t('FailedToUpdateAccountCard') + ' ' + t('CardNotEditable'));

            } else {
                toast.error(t('FailedToUpdateAccountCard'));
            }
        }
    };


    const [palCodeChanged, setPalCodeChanged] = useState(false);
    const handlePalCodeChange = (newValue) => {
        if (!selectedAccountCard.isEditable) {
            toast.info(t('CardNotEditable'));
            return;
        }

        if (selectedAccountCard.palCodeId !== newValue) {
            setPalCodeChanged(true);
            setSelectedAccountCardPalCode(newValue);
        } else {
            setPalCodeChanged(false);
        }
    };

    const handleSavePalCodeChange = () => {

        if (selectedAccountCardPalCode === t('NonPalCode')) {
            toast.info(t('NonPalcodeTypeAsPalcodeError'));
            return;
        }
        const updatedAccountCard = {
            palCodeId: selectedAccountCardPalCode,
            name: selectedAccountCard.name,
        };
        updateAccountCardPalCode(updatedAccountCard, selectedAccountCard);
        setPalCodeChanged(false);
        setOpenDialog(false);
    };
    // Calculate the total amount
    const totalAmount = selectedAccountCard
        ? selectedAccountCard.dateAmounts.reduce(
            (sum, da) => sum + (da ? da.amount : 0),
            0
        )
        : 0;

    const handleChangeAfterAdd = async (cardId, type) => {
        await fetchEnums(token, client);
    }

    useEffect(() => {
        // Only update if selectedAccountCard changes but editedAccountCard is not already set
        // This prevents overwriting the value set immediately in handleRightClickedRow
        if (selectedAccountCard && !editedAccountCard?.cardId) {
            const foundCard = accountCardOptions.find(card => card.cardId === selectedAccountCard.cardId);
            if (foundCard) {
                setEditedAccountCard({ ...foundCard, palCodeId: selectedAccountCard.palCodeId });
            }
        }
    }, [selectedAccountCard, accountCardOptions]);

    const buttonData = [
        {
            label: 'Actions',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'TrialBalance',
                    onClick: handleOpenHTMLModal,
                    icon: () => <DescriptionIcon fontSize="small" />,
                    show: !isProfitAndLoss,
                },
                {
                    label: 'BalanceControl',
                    onClick: handleOpenBalanceControlModal,
                    icon: () => <DescriptionIcon fontSize="small" />,
                },
                {
                    label: 'PalcodePlacementCheck',
                    onClick: () => handleOpenPalcodeCheckModal('PalcodePlacement'),
                    icon: () => <DescriptionIcon fontSize="small" />,
                },
                {
                    label: 'MissingPalCodeCheck',
                    onClick: () => handleOpenPalcodeCheckModal('MissingPalCode'),
                    icon: () => <DescriptionIcon fontSize="small" />,
                },
                {
                    label: 'WithholdingCardPaymentItemCheck',
                    onClick: () => handleOpenPalcodeCheckModal('WithholdingCardPaymentItem'),
                    icon: () => <DescriptionIcon fontSize="small" />,
                },
                {
                    label: 'ProfitAndLossReport',
                    onClick: handleOpenProfitAndLossReportHtml,
                    icon: () => <DescriptionIcon fontSize="small" />,
                    show: isProfitAndLoss,
                },
                {
                    label: 'EditableProfitAndLossReport',
                    onClick: handleOpenEditableProfitAndLossReport,
                    icon: () => <DescriptionIcon fontSize="small" />,
                    show: isProfitAndLoss,
                },
                ...(!isMonthly ? [{
                    label: 'MatchingProfitAndLossReport',
                    onClick: handleOpenMatchingProfitAndLossReport,
                    show: isProfitAndLoss,
                }] : []),
            ],
        },
    ];

    return (
        <>
            <BalanceControlDialog
                open={openBalanceControlModal}
                onClose={handleCloseBalanceControlDialog}
                balanceControlData={balanceControl}
                startDateBalance={startDate}
                endDateBalance={endDate}
                client={client}
            />
            <PalcodePlacementCheckDialog
                open={palcodeCheckType !== null}
                checkType={palcodeCheckType}
                onClose={handleClosePalcodePlacementDialog}
                violations={palcodePlacementViolations}
            />
            <AddAccountCardModal
                accountCardOptions={accountCardOptions}
                open={editedAddAccountCard}
                onClose={handleCloseItem}
                editedItem={editedAccountCard}
                isEdit={true}
                isRange={isRange}
                isClosedReportingMonth={isClosedReportingMonth}
                palCodes={formattedPalCodeOptions}
                propPalCode={palCode}
                setPalCode={setPalCode}
                direction={direction} // Pass direction for styling
                isAdd={!showAccountCardInputsEdit}
                client={client}
                token={token}
                setLoading={setLoading}
                handleChangeAfterAdd={handleChangeAfterAdd}
                fetchEnums={fetchEnums2}
                type={addAccountCardType}
                TrialBalanceSum={beautifyNumber(totalAmount)}
            />
            {/* <HamburgerMenu client={client} /> */}

            <>
                <>
                    <NavigationButton
                        t={t}
                        direction={direction}
                        data={buttonData}
                    />
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}`}>
                        <Box className="document-filter-row" dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('Search')}
                                value={searchQuery}
                                onChange={handleSearchChange}
                                className="document-search-bar"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className="document-search-icon" />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Box className="document-data-view">
                                <ToggleButtonGroup
                                    value={isMonthly ? 'monthly' : 'yearly'}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            handleRangeChange(newValue === 'monthly');
                                        }
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="yearly" aria-label="yearly">
                                        {t('Yearly')}
                                    </ToggleButton>
                                    <ToggleButton value="monthly" aria-label="monthly">
                                        {t('Monthly')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>

                            {isMonthly ? (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={`${headerStyles.dateSelectRange} ${headerStyles.dateSelectRangeCompact}`}>
                                    <div className={headerStyles.dateSelectYear}>
                                        <FilterMonthYearPicker
                                            year={startYearDate}
                                            onYearChange={(date) => handleStartDateChange(date)}
                                            labelYear={t('StartDate')}
                                            direction={direction}
                                            yearOnly
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelectYear}>
                                        <FilterMonthYearPicker
                                            year={endYearDate}
                                            onYearChange={(date) => handleEndDateChange(date)}
                                            labelYear={t('EndDate')}
                                            direction={direction}
                                            yearOnly
                                        />
                                    </div>
                                </div>
                            )}

                            <Box className="document-data-view">
                                <span className="document-data-view__label">{t('DataView')}</span>
                                <ToggleButtonGroup
                                    value={filterByDocumentDate ? 'document' : 'registration'}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            handleDateBasisChange(newValue === 'document');
                                        }
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="document" aria-label="document date">
                                        {t('DocumentDate')}
                                    </ToggleButton>
                                    <ToggleButton value="registration" aria-label="registration month">
                                        {t('RegistrationMonth')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>

                        <Box className="document-mode-toggles">
                            <Box className={`document-mode-toggle${showWithZeros ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showWithZeros}
                                            onChange={() => setShowWithZeros((prev) => !prev)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('ShowWithZeros') }}
                                        />
                                    }
                                    label={t('ShowWithZeros')}
                                />
                            </Box>
                            <Box className={`document-mode-toggle${!processedFilesCheckbox ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!processedFilesCheckbox}
                                            onChange={() => handleProcessFilesCheckboxClick(!processedFilesCheckbox)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('ShowUnprocessedDocuments') }}
                                        />
                                    }
                                    label={t('ShowUnprocessedDocuments')}
                                />
                            </Box>
                            <Box className={`document-mode-toggle${showAccountCardsWithZeros ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showAccountCardsWithZeros}
                                            onChange={() => setShowAccountCardsWithZeros((prev) => !prev)}
                                            size="small"
                                            inputProps={{ 'aria-label': t('ShowResetCards') }}
                                        />
                                    }
                                    label={t('ShowResetCards')}
                                />
                            </Box>
                        </Box>
                    </div>

                    <Box className="document-mode-toggles" dir={direction}>
                        <Box className={`document-mode-toggle${selectedSearchType === 'General' ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedSearchType === 'General'}
                                        onChange={handleChange}
                                        name="General"
                                        size="small"
                                    />
                                }
                                label={t('General')}
                            />
                        </Box>
                        <Box className={`document-mode-toggle${selectedSearchType === 'BalanceClassificationMazni' ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedSearchType === 'BalanceClassificationMazni'}
                                        onChange={handleChange}
                                        name="BalanceClassificationMazni"
                                        size="small"
                                    />
                                }
                                label={t('BalanceClassificationMazni')}
                            />
                        </Box>
                        <Box className={`document-mode-toggle${selectedSearchType === 'AccountCard' ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedSearchType === 'AccountCard'}
                                        onChange={handleChange}
                                        name="AccountCard"
                                        size="small"
                                    />
                                }
                                label={t('AccountCard')}
                            />
                        </Box>
                    </Box>

                    <TrialBalanceTable
                        palDates={palDates}
                        isMonthly={isMonthly}
                        palCodesData={filteredAndSortedPalCodesData}
                        footerTotals={footerTotals}
                        handleSortChange={handleSortChange}
                        handleSelect={handleSelect}
                        handleRightClickedRow={handleRightClickedRow}
                        selectedSearchType={selectedSearchType}
                        searchQuery={debouncedSearchQuery}
                        showAccountCardsWithZeros={showAccountCardsWithZeros}
                    />
                    </Box>

                </>
                {memoizedTrialBalanceReport}

                {memoizedProfitAndLossReport}
                
                {/* Hidden HTML generator for matching modal */}
                {memoizedMatchingHtmlGenerator}

                {/* Hidden HTML generator for editable report modal */}
                {memoizedEditableHtmlGenerator}

                {/* Matching Profit and Loss Report Modal */}
                {openMatchingProfitAndLossModal && client && profitAndLossYear && (
                    <ProfitAndLossHtmlPreview
                        open={openMatchingProfitAndLossModal}
                        htmlContent={profitAndLossHtmlContent}
                        onCancel={handleCloseMatchingProfitAndLossModal}
                        onOk={handleCloseMatchingProfitAndLossModal}
                        t={t}
                        withCancel={true}
                        title="MatchingProfitAndLossReport"
                        client={client}
                        token={token}
                        year={profitAndLossYear}
                        accountantId={client?.accountantId || ''}
                        isFromLedgerReport={true}
                        profitAndLossTotalBalance={profitAndLossTotalBalance}
                    />
                )}

                {/* Editable Profit and Loss Report Modal */}
                {openEditableProfitAndLossModal && client && (
                    <EditableProfitAndLossHtmlPreview
                        open={openEditableProfitAndLossModal}
                        htmlContent={editableProfitAndLossHtmlContent}
                        onCancel={handleCloseEditableProfitAndLossReport}
                        t={t}
                        title="EditableProfitAndLossReport"
                        client={client}
                        token={token}
                        isMonthly={isMonthly}
                        direction={direction}
                        showPercentageColumn={editableShowPercentageColumn}
                        setShowPercentageColumn={setEditableShowPercentageColumn}
                        reportData={trialBalanceData}
                        showAccountCardsWithZeros={showAccountCardsWithZeros}
                    />
                )}
                
                <ToastContainer />
                {(loading || !client) && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Large size for better visibility
                            color="#2CD852"   // Matches the green theme (if applicable)
                            loading={loading}
                        />
                        {!client && !loading && (
                            <p className="loader-message">{t('FetchingClientData')}</p>
                        )}
                    </div>
                )}

            </>
        </>
    );
}


export default LedgerReport;
